import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var BackdropTag = /*#__PURE__*/styled.div.withConfig({
  componentId: "hba0s0-0"
})(["", ";top:0;left:0;width:100%;height:100%;background:black;opacity:0.6;", ""], function (_ref) {
  var type = _ref.type;
  return type === 'cover' ? 'position: fixed' : 'position: absolute';
}, function (props) {
  return props.zIndex ? "z-index: ".concat(props.zIndex, ";") : '';
});
var DSBackdrop = function DSBackdrop(_ref2) {
  var _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'cover' : _ref2$type,
      zIndex = _ref2.zIndex,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {
    return null;
  } : _ref2$onClick;
  return /*#__PURE__*/React.createElement(BackdropTag, {
    zIndex: zIndex,
    type: type,
    onClick: onClick,
    "data-testid": "ds-backdrop"
  });
};
DSBackdrop.propTypes = {
  /**
   * ['cover', 'fill']
   */
  type: PropTypes.oneOf(['fill', 'cover']),

  /**
   * z-index of dimmer background
   */
  zIndex: PropTypes.number,

  /**
   * Backdrop click event
   */
  onClick: PropTypes.func
};

export default DSBackdrop;
export { DSBackdrop };
//# sourceMappingURL=Backdrop.js.map
